import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideOut12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSlideOut12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M4.635 2.22A3.78 3.78 0 0 1 7.37 3.607l-.64.644a2.88 2.88 0 0 0-2.29-1.136 2.885 2.885 0 0 0 0 5.77c.93 0 1.754-.442 2.282-1.125l.642.64A3.78 3.78 0 0 1 4.44 9.783l-.195-.005A3.785 3.785 0 0 1 .66 6.194L.655 6A3.786 3.786 0 0 1 4.44 2.215zm4.517 2.173a.45.45 0 0 1 .636 0l1.602 1.601-1.602 1.602a.45.45 0 0 1-.637-.637l.519-.518H6.448a.451.451 0 0 1 0-.9h3.216l-.513-.513a.45.45 0 0 1 .001-.635"
            />
        </svg>
    );
}
export default memo(IconArrowSlideOut12);
